export default __webpack_public_path__ + "static/media/el12.5e073666.svg";